<template>
  <label class="wrapper-radio mr-20 db relative pl-26 mb-6 hand fs-14 w-fit-content">
    <img :src="resolveImgUrl(url)" v-if="isImg" class="img-text" />
<!--    <span class="black v-sub fs-16 lh-24 fw-500 label-radio" v-if="!isImg">{{ label }}</span>-->
    <input
      class="checkbox absolute hand opacity-0 w-0 h-0 v-sub"
      type="radio"
      :name="name"
      :checked="isChecked"
      :value="value"
      @change="$emit('update:change', $event.target.value)"
    />
    <span class="black v-sub fs-14 lh-24 fw-500 label-radio gray-700-brand" v-if="!isImg">{{ label }}</span>
    <span class="checkmark absolute w-18 h-18 br-p-50 bg-white"></span>
  </label>
</template>

<script>
import { defineComponent } from "vue";
import { assetCDN } from '~/helper'

export default defineComponent({
  props: {
    url:{
      type: String,
      default: "",
    },
    isImg:{
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "",
      // required: true
    },
    name: {
      type: String,
      default: "",
      required: true
    },
    value: {
      type: String,
      default: null
    },
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  setup(){
    const ASSETS_CDN = assetCDN()
     const resolveImgUrl = (path) => {
      // let images = require.context('../../../assets/images/general', false, /\.png$|\.svg$/)
      // return images('./' + path)
      return `${ASSETS_CDN}/flags/` + path
    }

    return { resolveImgUrl }
  }
});
</script>

<style lang="scss" scoped>
.opacity-0 {
  opacity: 0;
}

.checkmark {
  top: 3px;
  left: 0;
  border: $bw-thin solid $border-hairline; // v2 §Radio — resting border 1→1.5px
  transition: border-color $dur-fast $ease-out; // §11
}

.wrapper-radio {
  input:checked ~ {
    .checkmark {
      background-color: #fff;
      border: $bw-thin solid $brand-green; // §9 checked green border (v2 1.5px, in sync with resting)
      &:after {
        content: "";
        position: absolute;
        display: none;
      }
    }
    .label-radio {
      color: $foreground;
      font-family: $font-family-base;
      font-weight: 500;
    }
  }
  // §14 focus ring on the visible control (native radio is visually hidden).
  // v2 (L217): 2px GREEN ring, 2px offset. Hard-set green rather than
  // @include focus-ring — the mixin emits &:focus-visible on the element
  // itself, but here focus lives on the hidden input and the ring must render
  // on the sibling `.checkmark`, which the mixin can't express.
  input:focus-visible ~ .checkmark {
    outline: 2px solid $brand-green;
    outline-offset: 2px;
  }
  // §9 disabled — v2 radio-specific 40% (not the global 0.5) + not-allowed.
  input:disabled ~ .checkmark { opacity: 0.4; }
  input:disabled ~ .label-radio { opacity: 0.4; cursor: not-allowed; }
  .img-text{
    //width: 56px;
    height: 15px;
    vertical-align: -webkit-baseline-middle;
  }
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.wrapper-radio input:checked ~ .checkmark:after {
  display: block;
}

.wrapper-radio .checkmark:after {
  // Center the 10px dot in the circle regardless of box-sizing — the global
  // `box-sizing: border-box` puts the 1.5px border inside the 18px box, so the
  // old fixed 4px/4px offsets landed the dot down-and-right of centre.
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px; // v2 §Radio — 10px inner green dot
  height: 10px;
  border-radius: 50%;
  background-color: $brand-green; // §9 selected dot (was brand,800)
}

// v2 (L217): grouped radios sit with a 12px vertical gap. RadioBox renders a
// SINGLE radio (no group wrapper), so that inter-radio spacing is the
// CONSUMER's responsibility — apply a 12px gap between stacked instances in
// the consuming markup (StepYourTrip.vue, TripPlanSetting.vue, NewCheckOut.vue,
// ModalDownload.vue, etc.). Do not add a group wrapper here.

@include phone{
  .wrapper-radio{
    width: fit-content;
    &:last-child{
      margin-bottom: 0;
    }
  }
}
</style>
